import React, { forwardRef } from 'react';
import { InputGroup, AutoComplete } from 'rsuite';
import FormFieldErrorIcon from './FormFieldErrorIcon';
import IconIndicator from '../user-feedback/IconIndicator';

export interface AutocompleteWithErrorBasicProps {
  data: Array<Record<string, any>>;
  errorMessage: string;
  hideErrorIcon?: boolean;
  isLoading?: boolean;
  name?: string;
  onChange: () => void;
  onSelect: (value: { address: string; components: string }) => Promise<void>;
  showError?: boolean;
  value?: string;
  loading?: string;
}

type AutocompleteWithErrorStatusProps = {
  errorMessage: string;
  hideErrorIcon?: boolean;
  isLoading?: boolean;
  showError?: boolean;
} & AutocompleteWithErrorBasicProps;

export const AutocompleteWithErrorStatus = React.memo(
  forwardRef<HTMLDivElement, AutocompleteWithErrorStatusProps>(
    (
      {
        showError,
        errorMessage,
        hideErrorIcon,
        data,
        onChange,
        onSelect,
        isLoading = false,

        ...props
      }: AutocompleteWithErrorStatusProps,
      ref
    ) => {
      return (
        <InputGroup
          role="group"
          {...props}
          ref={ref}
        >
          <AutoComplete
            aria-label={props?.name}
            data={data}
            onChange={onChange}
            onSelect={(selected) => {
              const match = data.find((add) => add === selected);
              onSelect({ address: selected, components: match?.components });
            }}
            value={props.value}
          />
          {!hideErrorIcon && showError && (
            <InputGroup.Addon
              tabIndex={-1}
              data-testid="error-addon"
            >
              <FormFieldErrorIcon errorMessage={errorMessage} />
            </InputGroup.Addon>
          )}
          {isLoading && (
            <InputGroup.Addon
              tabIndex={-1}
              style={{ backgroundColor: 'transparent' }}
            >
              <IconIndicator
                size={16}
                color="#D1D1D1"
              />
            </InputGroup.Addon>
          )}
        </InputGroup>
      );
    }
  )
);
